import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=68d2cbbc&scoped=true&"
import script from "./FilterSidebar.vue?vue&type=script&lang=js&"
export * from "./FilterSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2cbbc",
  null
  
)

export default component.exports